import { useTranslation } from 'react-i18next';
import carouselBackground from '../../assets/wave-bg.svg';
import { ActivityTemplate, TaggedTemplateCollection } from '../../models';
import { ActivityTemplateItem } from './ActivityTemplateItem';

function ActivityTemplateTagCarousel({
  taggedTemplateCollections,
}: {
  taggedTemplateCollections: TaggedTemplateCollection[];
}) {
  const activityTemplatesHasTag = taggedTemplateCollections.filter(
    (taggedTemplateCollection) =>
      typeof taggedTemplateCollection.id === 'number'
  );
  const activityTemplatesNoTag = taggedTemplateCollections.find(
    (taggedTemplateCollection) => taggedTemplateCollection.id === null
  );

  const TemplateNoTagItems = ({
    activityTemplates,
  }: {
    activityTemplates: ActivityTemplate[];
  }) => (
    <div
      className={
        'overflow-x-auto flex flex-nowrap mx-6 mt-8 gap-x-4 ' +
        (activityTemplates.length === 0 ? 'justify-center' : '')
      }
    >
      {activityTemplates.map((template) => (
        <ActivityTemplateItem
          key={template.id}
          template={template}
        ></ActivityTemplateItem>
      ))}
    </div>
  );

  const TemplatesHasTagItems = ({
    taggedTemplateCollection,
  }: {
    taggedTemplateCollection: TaggedTemplateCollection;
  }) => (
    <div>
      <div className="mt-8 text-md font-medium bg-white w-fit mx-6 rounded-lg shadow-card px-2 py-1">
        {taggedTemplateCollection.name}
      </div>
      <div className="overflow-x-auto flex flex-nowrap mx-6 mt-2 gap-x-4">
        {taggedTemplateCollection.templates.map((template) => (
          <ActivityTemplateItem
            key={template.id}
            template={template}
          ></ActivityTemplateItem>
        ))}
      </div>
    </div>
  );

  return (
    <div>
      {activityTemplatesNoTag && (
        <TemplateNoTagItems
          activityTemplates={activityTemplatesNoTag.templates}
        />
      )}
      {activityTemplatesHasTag.length > 0 &&
        activityTemplatesHasTag.map((taggedTemplateCollection) => (
          <TemplatesHasTagItems
            key={taggedTemplateCollection.id}
            taggedTemplateCollection={taggedTemplateCollection}
          />
        ))}
    </div>
  );
}

export default function ActivityTemplateCarousel({
  taggedTemplateCollections,
}: {
  taggedTemplateCollections: TaggedTemplateCollection[];
}) {
  const [t] = useTranslation(['chatroom']);
  const style = {
    backgroundImage: `url(${carouselBackground})`,
  };
  return (
    <div
      style={style}
      className="bg-no-repeat bg-cover w-full flex flex-col flex-grow py-12 justify-center"
    >
      {taggedTemplateCollections.length > 0 ? (
        <span className="text-center font-bold text-xl">
          {t('activity_templates_carousel_title', '看看有哪些 可用的活動類型')}
        </span>
      ) : (
        <></>
      )}
      <ActivityTemplateTagCarousel
        taggedTemplateCollections={taggedTemplateCollections}
      />
    </div>
  );
}
